import { createFileRoute, useSearch } from '@tanstack/react-router';
import { ContainerTypeLegacy, DevicesLayout, navigateToError } from '@amber-ui/core';

function BargeDevicesRoute() {
  const { barge } = useSearch({ strict: false }) as { barge?: string };
  const barge_id = barge || null;

  if (!barge_id) return null;

  return (
    <DevicesLayout
      container_id={barge_id}
      container_type={ContainerTypeLegacy.barge}
      onError={() => {
        navigateToError();
      }}
      onHubAssignmentSuccess={() => {}}
      onAssignFanControllerSuccess={() => {}}
      onUnassignFanControllerSuccess={() => {}}
    />
  );
}

export const Route = createFileRoute('/_auth/_barge/barge/devices')({
  component: BargeDevicesRoute,
});
